var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentuploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9998 12.5V7.5C14.9998 5.14297 14.9998 3.96447 14.2676 3.23223C13.5353 2.5 12.3568 2.5 9.99984 2.5H6.6665C4.30948 2.5 3.13097 2.5 2.39874 3.23223C1.6665 3.96447 1.6665 5.14297 1.6665 7.5V12.5C1.6665 14.857 1.6665 16.0355 2.39874 16.7677C3.13097 17.5 4.30948 17.5 6.6665 17.5H16.6665",
    stroke: "#F4F4F4",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 6.6665H11.6667",
    stroke: "#F4F4F4",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 10H11.6667",
    stroke: "#F4F4F4",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5 13.3335H8.33333",
    stroke: "#F4F4F4",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15 6.6665H15.8333C17.0118 6.6665 17.6011 6.6665 17.9672 7.03262C18.3333 7.39874 18.3333 7.988 18.3333 9.1665V15.8332C18.3333 16.7537 17.5872 17.4998 16.6667 17.4998C15.7462 17.4998 15 16.7537 15 15.8332V6.6665Z",
    stroke: "#F4F4F4",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentuploadIcon);
export default __webpack_public_path__ + "static/media/documentupload-icon.4b353d5994b0bed823ed8b3d43b0911a.svg";
export { ForwardRef as ReactComponent };